export const SKU_LIST = 'SKU_LIST'
export const UPDATE_SKU = 'UPDATE_SKU'



// WEBPACK FOOTER //
// ./src/store/actions/sku.js